/**
 * Created by fers on 26.09.15.
 */

import { v4 as uuidv4 } from 'uuid';
import { declareEntity } from '../fw/MetaDataHelper.ts';
import * as Permission from '../util/Permission';
import { FLOW_DEF_VERSION_ID_DEVELOPMENT } from './FlowDefVersionType';

export default declareEntity({
    entity: "groupDefs",
    graphQL: "GroupDef",
    name: "Group Definition",
    dynamoPrefix: 'def',
    storageType: 'schema',
    writePermission: [
        Permission.PERM_EDIT_CHANNEL_DEF
    ],
    defaultOrder: [['isSystem', 'DESC'], 'name', 'key'],
    defaultTitle: (data) => {
        return data['name'];
    },
    isPublic: true,
    fields: (types) => { return {
        id: {
            name: "Group Definition ID",
            type: "id",
            defaultValue: () => {
                return uuidv4();
            },
            primaryKey: true,
            required: true,
            userEditable: false,
            isPublic: true,
        },
        name: {
            name: "Name",
            trim: true,
            type: "string",
            translatable: true,
            defaultValue: "",
            required: true,
            filterable: true,
            isPublic: true,
        },
        key: {
            name: "Key",
            trim: true,
            type: "string",
            defaultValue: "com.service",
            validations: {
                matchRegexp: /^[a-zA-Z0-9\.\-]+$/,
            }
        },
        parent: {
            name: "Parent group",
            type: "relation",
            to: () => types['groupDefs'],
            defaultValue: (groupDef) => {
                return groupDef ? groupDef['id'] : null;
            },
            hiddenCreate: true,
        },
        channelDef: {
            name: "Application Definition",
            to: () => types['channelDefs'],
            type: "relation",
        },
        groupDefVersion: {
            name: "Group Definition Version",
            to: () => types['groupDefVersions'],
            type: "relation",
            defaultValue: (flow) => {
                return flow['groupDefVersion_id'] || FLOW_DEF_VERSION_ID_DEVELOPMENT;
            },
            required: true,
            hiddenCreate: true,
            compositeKey: true,
        },
        developerGroup: {
            name: "Developer",
            type: "relation",
            to: () => types['developerGroups'],
            userEditable: false,
            filterable: true,
        },
        description: {
            name: "Description",
            type: "text",
            translatable: true,
            defaultValue: ""
        },
        isComponent: {
            name: "Component",
            type: "boolean",
            defaultValue: false,
            writePermission: [
                Permission.PERM_DEVELOPER
            ],
        },
        isSystem: {
            name: "System",
            type: "boolean",
            defaultValue: false,
            writePermission: [
                Permission.PERM_DEVELOPER
            ],
        },
        versionConfig: {
            name: "Version Config",
            type: "object",
            import: false,
            export: false,
            userEditable: false,
            permission: Permission.PERM_DEVELOPER,
        },
        originalGroupDefVersion: {
            name: "Original Group Definition Version",
            to: () => types['groupDefVersions'],
            type: "relation",
            export: false,
            userEditable: false,
            permission: Permission.PERM_DEVELOPER,
        },
        hasChange: {
            name: "Has Change",
            type: "boolean",
            filterable: true,
            export: false,
            import: false,
            userEditable: false,
            isPublic: false,
            permission: Permission.PERM_DEVELOPER,
        },
        author: {
            name: "Author",
            type: "relation",
            to: () => types['users'],
            userEditable: false,
        },
        changeAuthor: {
            name: "Last change author",
            type: "relation",
            userEditable: false,
            to: () => types['users'],
        },
        changeAuthorName: {
            name: "Change Author Name",
            type: "string",
            userEditable: false,
        },
        updatedAt: {
            name: "Updated At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        },
        createdAt: {
            name: "Created At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        }
    }; },
    relations: (types) => { return {
        entityDefs: {
            type: 'oneToMany',
            to: types['entityDefs'],
            export: true,
            foreignKeys: [
                {
                    from: "id",
                    to: "groupDef_id"
                }
            ]
        },
        groupDefVersions: {
            type: 'oneToMany',
            to: types['groupDefVersions'],
            export: false,
            permission: Permission.PERM_INSTANCE_ADMIN,
            foreignKeys: [
                {
                    from: "id",
                    to: "groupDef_id"
                }
            ]
        },

    }; }

});
